// Native RTMPS broadcaster bridge (Capacitor custom plugin).
//
// Android: implemented with RootEncoder (GenericStream). iOS: HaishinKit.
// The plugin opens the device camera, renders a preview BEHIND the (transparent)
// WebView and pushes an RTMPS stream straight to Cloudflare — which records the
// replay server-side, so the phone never has to record + upload a heavy file.
//
// When the plugin is not present (e.g. an iOS build without HaishinKit yet, or a
// web build), `rtmpBroadcastAvailable()` is false and callers fall back to WHIP.
import { registerPlugin, Capacitor } from "@capacitor/core";

const Plugin = registerPlugin("RtmpBroadcaster");

export const rtmpBroadcastAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("RtmpBroadcaster");

// Ask for CAMERA + MICROPHONE. Returns true only when both are granted.
export async function ensureRtmpPermissions() {
  try {
    let st = await Plugin.checkPermissions();
    if (!(st && st.camera === "granted" && st.microphone === "granted")) {
      st = await Plugin.requestPermissions();
    }
    return !!(st && st.camera === "granted" && st.microphone === "granted");
  } catch {
    return false;
  }
}

export const startRtmpPreview = (opts = {}) => Plugin.startPreview(opts);
export const startRtmpBroadcast = (opts) => Plugin.startBroadcast(opts);
export const stopRtmpBroadcast = () => Plugin.stopBroadcast().catch(() => {});
export const stopRtmpPreview = () => Plugin.stopPreview().catch(() => {});
export const switchRtmpCamera = () => Plugin.switchCamera().catch(() => {});
export const setRtmpMuted = (muted) => Plugin.setMuted({ muted }).catch(() => {});
// Lot 639 — filtres du direct : {matrix: 25 floats (lib/mediaFx fxMatrix) | null, identity, beauty 0|1|2}.
// Ancien build sans la méthode → rejet avalé (le flux reste sans filtre).
export const setRtmpFilter = (opts) => Plugin.setFilter(opts).catch(() => null);
export const addRtmpListener = (event, cb) => Plugin.addListener(event, cb);

// Full RTMPS endpoint Cloudflare expects: server URL + stream key joined by a slash.
export function buildRtmpsEndpoint(rtmpsUrl, rtmpsKey) {
  if (!rtmpsUrl) return "";
  let base = String(rtmpsUrl).trim();
  const key = String(rtmpsKey || "").trim();
  if (!key) return base;
  if (!base.endsWith("/")) base += "/";
  return base + key;
}
